import { AdminCaseList } from "pwapi";

import { CaseAdminDetail } from "./adminCaseReducer";
import {
  ADMIN_CASE_SUCCESS,
  ADMIN_CASES_SUCCESS,
  ADMIN_CASES_FAILURE,
  ADMIN_CASES_REQUEST,
  ADMIN_UPDATE_CASE_SUCCESS,
  ADMIN_UPDATE_SLIDE_SUCCESS,
  ADMIN_UPDATE_SLIDE_CASES_FAILURE,
  ADMIN_UPDATE_SLIDE_REQUEST,
  ADMIN_DELETE_SLIDE_SUCCESS,
  ADMIN_SLIDE_BARCODE_SET,
  ADMIN_SLIDE_MACRO_SET,
  SET_LAST_ADMIN_CASE_VIEWED,
  TOGGLE_BULK_COLUMNS,
  ADMIN_CASE_FAILURE,
} from "../../actions/adminConstants";

export type AdminCaseListDetail = CaseAdminDetail & {
  detailLoaded: boolean;
  detailError: boolean;
};

export interface AdminCasesState {
  count?: number;
  count_specimen?: number;
  next?: string;
  previous?: string;
  results: Array<AdminCaseList | AdminCaseListDetail>;
  slideCount?: number;
  loading?: boolean;
  lastViewed?: number;
  params?: any;
  bulkAssignColumns?: boolean;
}

export const initialState = {
  results: [],
  bulkAssignColumns: false,
};

let i;

const reducer = (state: AdminCasesState = initialState, action: any): any => {
  switch (action.type) {
    case ADMIN_CASE_SUCCESS:
      i = state.results.findIndex((c) => c.id === action.payload.response.id);
      if (i < 0) return state;
      return {
        ...state,
        results: state.results.slice(0, i).concat(
          [
            {
              ...action.payload.response,
              detailLoaded: true,
              detailError: false,
            },
          ],
          state.results.slice(i + 1)
        ),
      };
    case ADMIN_CASE_FAILURE:
      i = state.results.findIndex((c) => c.id === action.args);
      if (i < 0) return state;
      return {
        ...state,
        results: state.results.slice(0, i).concat(
          [
            {
              ...state.results[i],
              detailLoaded: !!(state.results[i] as AdminCaseListDetail)
                .detailLoaded,
              detailError: true,
            },
          ],
          state.results.slice(i + 1)
        ),
      };
    case SET_LAST_ADMIN_CASE_VIEWED:
      return {
        ...state,
        lastViewed: action.payload,
      };
    case ADMIN_CASES_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ADMIN_CASES_SUCCESS:
      return {
        ...state,
        ...action.payload,
        loading: false,
      };
    case ADMIN_CASES_FAILURE:
      return {
        ...state,
        params: {},
        loading: false,
        error: action.payload,
      };
    case ADMIN_UPDATE_CASE_SUCCESS:
      return state && state.results.length
        ? {
            ...state,
            results: state.results.map((adminCase) => {
              return adminCase.id === action.payload.id
                ? {
                    ...adminCase,
                    ...action.payload,
                  }
                : adminCase;
            }),
          }
        : state;
    case ADMIN_UPDATE_SLIDE_REQUEST:
      const slideCase = action.payload.slide.case || action.payload.case;

      return state && state.results.length && slideCase
        ? {
            ...state,
            results: state.results.map((adminCase) => {
              return adminCase.id === slideCase.id
                ? {
                    ...adminCase,
                    slides: adminCase.slides.map((slide) => {
                      return slide.id === action.payload.slide.id
                        ? {
                            ...slide,
                            isLoading: true,
                          }
                        : slide;
                    }),
                  }
                : adminCase;
            }),
          }
        : state;
    case ADMIN_UPDATE_SLIDE_CASES_FAILURE:
      return state && action.payload.case
        ? {
            ...state,
            results: state.results.map((adminCase) => {
              return action.payload.case &&
                adminCase.id === action.payload.case.id
                ? {
                    ...adminCase,
                    slides: adminCase.slides.map((slide) => {
                      return slide.id === action.payload.slide.id
                        ? {
                            ...slide,
                            isLoading: false,
                          }
                        : slide;
                    }),
                  }
                : adminCase;
            }),
          }
        : state;
    case ADMIN_UPDATE_SLIDE_SUCCESS:
      const isOriginalCase =
        !!action.payload.case &&
        // Find the case portended by the updated slide, then find a slide which matches that case. If a slide is found, its the original case.
        !!state?.results
          ?.find((adminCase) => adminCase.id === action.payload.case.id)
          ?.slides?.find((slide) => slide.id === action.payload.id);

      const originalCase = !isOriginalCase
        ? // Find the original case the slide was in for use in the state update.
          state?.results?.find((adminCase) =>
            adminCase.slides.find((slide) => slide.id === action.payload.id)
          )
        : action.payload.case;

      return state && action.payload.case
        ? {
            ...state,
            results: state.results.map((adminCase) => {
              return action.payload.case &&
                adminCase.id === action.payload.case.id
                ? {
                    ...adminCase,
                    status: action.payload.case.status,
                    slides: isOriginalCase
                      ? adminCase.slides.map((slide) => {
                          return slide.id === action.payload.id
                            ? {
                                ...slide,
                                ...action.payload,
                                isLoading: false,
                              }
                            : slide;
                        })
                      : adminCase.slides
                      ? [
                          ...adminCase.slides,
                          { ...action.payload, isLoading: false },
                        ]
                      : [{ ...action.payload, isLoading: false }],
                  }
                : isOriginalCase
                ? adminCase
                : originalCase && originalCase.id === adminCase.id
                ? {
                    ...adminCase,
                    slides: adminCase.slides.filter(
                      (slide) => slide.id !== action.payload.id
                    ),
                  }
                : adminCase;
            }),
          }
        : state;
    case ADMIN_SLIDE_BARCODE_SET:
      return {
        ...state,
        results: state.results.map((adminCase) => {
          return adminCase.id === action.payload.caseId
            ? {
                ...adminCase,
                slides: adminCase.slides.map((slide) => {
                  return slide.id === action.payload.slideId
                    ? {
                        ...slide,
                        barcode_url: action.payload.url,
                      }
                    : slide;
                }),
              }
            : adminCase;
        }),
      };
    case ADMIN_SLIDE_MACRO_SET:
      return {
        ...state,
        results: state.results.map((adminCase) => {
          return adminCase.id === action.payload.caseId
            ? {
                ...adminCase,
                slides: adminCase.slides.map((slide) => {
                  return slide.id === action.payload.slideId
                    ? {
                        ...slide,
                        macro_url: action.payload.url,
                      }
                    : slide;
                }),
              }
            : adminCase;
        }),
      };
    case ADMIN_DELETE_SLIDE_SUCCESS:
      return {
        ...state,
        results: state.results.map((adminCase) => {
          return adminCase.id === action.payload.case_id
            ? {
                ...adminCase,
                slides: (adminCase as AdminCaseListDetail).slides.filter(
                  (slide) => {
                    return slide.id !== action.payload.slide_id;
                  }
                ),
              }
            : adminCase;
        }),
      };
    case TOGGLE_BULK_COLUMNS:
      return {
        ...state,
        bulkAssignColumns: !state.bulkAssignColumns,
      };
    default:
      return state;
  }
};

export default reducer;
